import { render, staticRenderFns } from "./import-wizard-v2.vue?vue&type=template&id=46c090e9"
import script from "./import-wizard-v2.vue?vue&type=script&lang=ts"
export * from "./import-wizard-v2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports